import { create } from "zustand";

export const notificationStore = create((set) => ({
  notifications: [],
  unreadCount: 0,

  setNotifications: (data) => {
    set((state) => {
      return {
        ...state,
        notifications: data,
      };
    });
  },

  setUnreadCount: (data) => {
    set((state) => {
      return {
        ...state,
        unreadCount: data,
      };
    });
  },
}));